module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Done-circle-8ab28bc1ba13e38aaa9dcc40443ca411.svg";